import React, {useEffect, useState} from 'react';
import {BarChartOutlined, UserOutlined} from '@ant-design/icons';
import {BiTransfer} from 'react-icons/bi';
import {VscLiveShare} from 'react-icons/vsc';
import {MdOutlinePointOfSale} from 'react-icons/md';
import {FaHandHoldingUsd} from 'react-icons/fa';
import {Item, Link, Logo, Menu, Sider, SubMenu, TecpayLogo,} from '../styles';
import {ISideMenuProps} from '../types';
import {IConfigData} from "../../../store/config/types";
import {isHiddenFeatureDomain} from "../../../config";
import { PortalPermissions, can } from "../../../config/permissions";
import logo from "../../../assets/tecpay-no-bg.png";
import {CiMoneyBill} from "react-icons/ci";
import {LiaFileSignatureSolid} from "react-icons/lia";
import {userCommercial} from "../../../utils/generalFormat";

const SideMenu: React.FC<ISideMenuProps> = (props: ISideMenuProps) => {
  const {collapsed} = props;
  const [primaryColor, setPrimaryColor] = useState('');
  const [logoUrl, setLogoUrl] = useState('');

  const selectedBusiness = localStorage.getItem("selectedCompany")
        ? JSON.parse(localStorage.getItem("selectedCompany") as string)
        : null;
      const commercialHierId = selectedBusiness?.commercialHierId;
      const commercialOwner = userCommercial(commercialHierId);

  useEffect(() => {
    const domain = window.location.hostname;
    const cachedConfig: IConfigData = JSON.parse(localStorage.getItem(`config_${domain}`) as string);
    if (cachedConfig) {
      setPrimaryColor(cachedConfig.corPrimaria);
      setLogoUrl(cachedConfig.linkImagem2);
    } else {
      setPrimaryColor('#0e2b27');
    }
  }, []);

  return (
    <Sider
      width={200}
      className="site-layout-background"
      trigger={null}
      collapsible
      collapsed={collapsed}
      style={{backgroundColor: primaryColor}}
    >
      <Logo to="/painel-de-recebiveis">
        <TecpayLogo src={logoUrl || logo}/>
      </Logo>
      <Menu
        mode="inline"
        theme="dark"
        style={{backgroundColor: primaryColor}}
      >

        {commercialHierId !== 290 && !isHiddenFeatureDomain()
          && can(PortalPermissions.conta.acessoConta.acessar) && (
          <Item icon={<UserOutlined />} key="">
          <a
            target="_blank"
            rel="noreferrer"
            href="https://banking.valori.com.vc/login"
          >
            <b>Acesso à conta</b>
          </a>
        </Item>
        )}

        {selectedBusiness?.splitEnabled && can(PortalPermissions.financeiro.extrato.acessar) && (
          <Item icon={<BarChartOutlined/>} key="paymentStatement">
            <Link to="/extrato">
              Extrato
            </Link>
          </Item>
        )}
      </Menu>
    </Sider>
  );
};

export default SideMenu;
